<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}</label>
              <el-form-item prop="cif">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.cif.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('persons_data.nombre_completo')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.location') }}</label>
              <el-form-item prop="direccion">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.direccion.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
              <el-form-item prop="email">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="500"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
              <el-form-item prop="registro_mercantil">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.registro_mercantil.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.codigo_postal') }}</label>
              <el-form-item prop="codigo_postal">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.codigo_postal.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>
          
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
              <el-form-item prop="telefono">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.telefono.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.pais') }}</label>
              <el-form-item prop="pais">
                <base-el-select class="w-full" :options="tiposPais" v-model="form.pais.value" clearable />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'invoicesIssuing/1',
      isOpen: this.panelOpen,
      form: {
        cif: { label: i18n.t('companies.cif'), value: '' },
        name: { label: i18n.t('companies.companyName'), value: '' },
        direccion: { label: i18n.t('address.location'), value: '' },
        registro_mercantil: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        codigo_postal: { label: i18n.t('address.codigo_postal'), value: '' },
        telefono: { label: i18n.t('address.telefono'), value: '' },
        pais: { label: i18n.t('address.pais'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  mounted: async function () {
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposPais: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.cif.value = _temp.cif !== undefined && _temp.cif ? _temp.cif.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name ? _temp.name.value : ''
        this.form.direccion.value = _temp.direccion !== undefined && _temp.direccion ? _temp.direccion.value : ''
        this.form.registro_mercantil.value = _temp.registro_mercantil !== undefined && _temp.registro_mercantil ? _temp.registro_mercantil.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.codigo_postal.value = _temp.codigo_postal !== undefined && _temp.codigo_postal.value !== '' ? _temp.codigo_postal.value : ''
        this.form.telefono.value = _temp.telefono !== undefined && _temp.telefono.value !== '' ? _temp.telefono.value : ''
        this.form.pais.value = _temp.pais !== undefined && _temp.pais.value !== '' ? _temp.pais.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        cif: { label: i18n.t('companies.cif'), value: '' },
        name: { label: i18n.t('companies.companyName'), value: '' },
        direccion: { label: i18n.t('address.location'), value: '' },
        registro_mercantil: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        codigo_postal: { label: i18n.t('address.codigo_postal'), value: '' },
        telefono: { label: i18n.t('address.telefono'), value: '' },
        pais: { label: i18n.t('address.pais'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
